export const FAVORITES_QUERY_KEY = 'favorites';
